import React from 'react';
import Badge from 'housecall-ui/dist/DesignSystem/DataDisplay/Badges/Badge';
import Tooltip from 'housecall-ui/dist/DesignSystem/DataDisplay/Tooltips/Tooltip';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import PropTypes from 'prop-types';

import TrackedButton from 'components/Common/Inputs/Buttons/TrackedButton';

import IconState from './navbarShortcutStates';

function ShortcutIcons({ lightMode, onMyAppsClick, showCompanySetup, quickbooksBadgeData }) {
  const toolbarIcons = IconState({ onMyAppsClick, showCompanySetup, quickbooksBadgeData });

  return (
    <>
      {toolbarIcons
        .filter((item) => item.show)
        .map((item, index) => (
          <Tooltip key={index} title={item.title}>
            <TrackedButton
              trackingName={`navbar ${item.value}`}
              trackingProperties={{ button_label: item.title }}
              buttonComponent={IconButton}
              size="medium"
              version="v2"
              coloredAtRest={lightMode}
              onClick={item.onClick}
            >
              <Badge color="info" version="v2" variant={item.badgeVariant} badgeContent={item.badgeCount}>
                {item.icon}
              </Badge>
            </TrackedButton>
          </Tooltip>
        ))}
    </>
  );
}

ShortcutIcons.propTypes = {
  lightMode: PropTypes.bool,
  onMyAppsClick: PropTypes.func,
  showCompanySetup: PropTypes.bool,
  quickbooksBadgeData: PropTypes.shape({
    qboErrorCount: PropTypes.number,
    qbdErrorCount: PropTypes.number,
    qboEnabled: PropTypes.bool,
    qbdEnabled: PropTypes.bool,
  }),
};

export default ShortcutIcons;
